module.exports = __webpack_public_path__ + "static/media/ReactLogo_NoShadow.aa7ca908.svg";